/**
 * 原生复制剪切板
 * 注:
 * (1) Clipboard 对象提供了四个方法，用来读写剪贴板。它们都是异步方法，返回 Promise 对象
 *     a、http的网址下无法调用, 需要https等安全上下文
 * (2) Document.execCommand()是操作剪贴板的传统方法，各种浏览器都支持。
 * 参考地址:
 * https://www.ruanyifeng.com/blog/2021/01/clipboard-api.html
 * https://www.cnblogs.com/rsapaper/p/15049494.html
 * 2023.02.23
 * https://juejin.cn/post/7031788217275940901
 *
 * 问题(未解决):
 * 目前调用过各种使用剪切板的api,异步的使用方案存在一个bug,
 * 当按发F12打开控制台或者进行断点测试时，复制剪切板都不会生效,并提示DOMException: Document is not focused.
 * 思考:
 * 因为代码运行的时候，开发者工具窗口是当前页，这个页面不存在 Clipboard API 依赖的 DOM 接口
 */

export function useClipboard() {
  // document.execCommand('copy')
  const execCommandCopy = (text: string) => {
    // 把需要复制的文本放入 <span>
    const fakeElement = document.createElement('textarea')
    fakeElement.value = text
    // 保留文本样式
    fakeElement.style.whiteSpace = 'pre'

    // 把 <textarea> 放进页面
    document.body.appendChild(fakeElement)
    if (!fakeElement.hasAttribute('readonly')) {
      fakeElement.setAttribute('readonly', '')
      fakeElement.select()
      fakeElement.setSelectionRange(0, fakeElement.value.length)
    }

    // 创建选择区域
    // const selection = window.getSelection() as Selection
    // const range = window.document.createRange()
    // selection.removeAllRanges()
    // range.selectNode(fakeElement)
    // selection.addRange(range)

    // 复制文本到剪切板
    let success = false
    try {
      success = document.execCommand('copy', true)
    } catch (err) {
      console.log('error', err)
    }

    // 清除战场
    // selection.removeAllRanges()
    fakeElement.removeAttribute('readonly')
    document.body.removeChild(fakeElement)
    return success
      ? Promise.resolve()
      : Promise.reject(new DOMException('The request is not allowed', 'NotAllowedError'))
  }

  // navigator.clipboard + document.execCommand('copy')
  const clipboardCopy = async (text: string) => {
    if (navigator.clipboard && window.isSecureContext) { // 如果浏览器兼容该 API
      return navigator.clipboard.writeText(text).catch(function () {
        return execCommandCopy(text)
      })
    }
    return execCommandCopy(text)
  }
  return { clipboardCopy }
}
